<!-- ── Hero: what this site is + shortcuts into the main categories ─────────────
A new visitor previously landed straight on the "סרטונים" reels strip with
no statement of what Sale4All is or where to start. This block answers
both, above everything else. -->
<section class="home-hero" dir="rtl">
  <p class="home-hero__eyebrow">השוק של כולנו</p>
  <h1 class="home-hero__title">כל מה שאתם מחפשים, במקום אחד</h1>
  <p class="home-hero__sub">קונים ומוכרים, מוצאים בעלי מקצוע ומגלים הזדמנויות עבודה בכל הארץ</p>

  <nav class="intent-grid" aria-label="מה תרצו לעשות ב-Sale4All">
    <a class="intent-card" routerLink="/search">
      <span class="intent-card__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path>
        </svg>
      </span>
      <span class="intent-card__copy"><strong>חיפוש מודעות</strong><small>רכב, נדל״ן, יד שנייה ועוד</small></span>
      <span class="intent-card__arrow" aria-hidden="true">←</span>
    </a>

    <a class="intent-card intent-card--primary" routerLink="/publish">
      <span class="intent-card__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14M5 12h14"></path>
        </svg>
      </span>
      <span class="intent-card__copy"><strong>פרסום מודעה</strong><small>מפרסמים בקלות ומגיעים לקונים</small></span>
      <span class="intent-card__arrow" aria-hidden="true">←</span>
    </a>

    <a class="intent-card" routerLink="/shop/coworker">
      <span class="intent-card__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.5 6a3.5 3.5 0 0 0 4.6 4.3l-8.4 8.4a2.4 2.4 0 0 1-3.4-3.4l8.4-8.4A3.5 3.5 0 0 0 14.5 6Z"></path>
        </svg>
      </span>
      <span class="intent-card__copy"><strong>מציאת בעל מקצוע</strong><small>אנשי מקצוע ושירותים קרוב אליכם</small></span>
      <span class="intent-card__arrow" aria-hidden="true">←</span>
    </a>

    <a class="intent-card" routerLink="/shop/required">
      <span class="intent-card__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 8h16v11H4zM9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M4 13h16"></path>
        </svg>
      </span>
      <span class="intent-card__copy"><strong>חיפוש עבודה</strong><small>משרות והזדמנויות חדשות</small></span>
      <span class="intent-card__arrow" aria-hidden="true">←</span>
    </a>
  </nav>

  <h2 class="home-hero__categories-title">או התחילו מקטגוריה</h2>

  <nav class="cat-shortcuts" aria-label="קטגוריות מובילות">
    @for (cat of shortcutCategories | slice:0:4; track cat) {
      <a class="cat-shortcut"
        [routerLink]="['/shop', cat.slug]">
        <span class="cat-shortcut__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="cat.icon"/>
          </svg>
        </span>
        <span class="cat-shortcut__label">{{ cat.label }}</span>
      </a>
    }

    <a class="cat-shortcut cat-shortcut--all" routerLink="/search">
      <span class="cat-shortcut__ico" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </span>
      <span class="cat-shortcut__label">כל הקטגוריות</span>
    </a>
  </nav>
</section>

<app-carousel-slider></app-carousel-slider>

<!-- ── Stories / reels ─────────────────────────────────────────────────────── -->
<!-- The reels bar renders its own <h2> from [title], so the page outline is
h1 (hero) → h2 (section titles) → h3 (card titles) with no skipped levels. -->
<div class="home-block home-block--stories">
  <app-reels-bar
    [reels]="reelsData"
    [title]="'מה חדש ב-Sale4All'"
    [rtl]="true"
    [visibleCount]="4"
    (onReelClick)="onReelClick($event)"
    (onLike)="onLike($event)"
    (onShare)="onShare($event)"
    (onContact)="onContact($event)"
    (onWhatsapp)="onWhatsapp($event)"
    (onSeeAll)="onSeeAll()"
  ></app-reels-bar>
</div>

<!-- ── Personalized sections — ordered by user interest ───────────────── -->
<div class="home-sections">

  <section class="market-section" [style.order]="getOrder('Car')" aria-label="מודעות רכב">
    <app-car-listings></app-car-listings>
  </section>

  <section class="market-section" [style.order]="getOrder('Nadlan')" aria-label="מודעות נדלן">
    <app-nadlan-listings></app-nadlan-listings>
  </section>

  <section class="market-section market-section--professionals" [style.order]="getOrder('Coworker')" aria-label="בעלי מקצוע ועובדים">
    <app-advertisement [advertisementType]="AdvertisementEnum.BANNER_ADV"></app-advertisement>
    <app-workers
      [sectionTitle]="'בעלי מקצוע מומלצים'"
      [sectionSubtitle]="'מצאו את איש המקצוע המתאים למשימה שלכם'"
    ></app-workers>
  </section>

  <section class="market-section" [style.order]="getOrder('Pet')" aria-label="חיות מחמד">
    <app-advertisement [advertisementType]="AdvertisementEnum.BANNER_ADV"></app-advertisement>
    <app-pet-listings></app-pet-listings>
  </section>

  <section class="market-section" [style.order]="getOrder('Sale2')" aria-label="מוצרי יד שנייה">
    <app-advertisement [advertisementType]="AdvertisementEnum.BANNER_ADV"></app-advertisement>
    <app-sale2-listings></app-sale2-listings>
  </section>

</div>

<!-- ── Trust signals ────────────────────────────────────────────────────────
Moved below the marketplace content: sitting above the carousel it just
pushed the actual listings down. Reassurance is what you read after
you've seen something you want, not before. Icons are inline SVG to
match the rest of the page rather than mixing in a second icon set. -->
<section class="confidence-strip" aria-label="למה Sale4All" dir="rtl">
  <div class="confidence-item">
    <span class="confidence-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3l7.5 3v5.5c0 4.4-3.1 8.3-7.5 9.5-4.4-1.2-7.5-5.1-7.5-9.5V6L12 3z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    </span>
    <span><strong>קנייה בראש שקט</strong><small>כלים לחוויה בטוחה ואמינה</small></span>
  </div>
  <div class="confidence-item">
    <span class="confidence-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    </span>
    <span><strong>קרוב אליכם</strong><small>מודעות, שירותים ומשרות מכל הארץ</small></span>
  </div>
  <div class="confidence-item">
    <span class="confidence-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </svg>
    </span>
    <span><strong>קשר ישיר</strong><small>מדברים ישירות עם מפרסמים</small></span>
  </div>
</section>

<router-outlet></router-outlet>
